export default __webpack_public_path__ + "static/media/heartIcon.db2e0270.svg";